import {
  SectionElement,
  defineElement,
  onClick,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-CFQW6ARL.js";

// src/sections/common-collection-grid/common-collection-grid.ts
var CommonCollectionGrid = class extends SectionElement {
  connectedCallback() {
    return __async(this, null, function* () {
      var me = this;
      if (this.checkTruncation(me.description)) {
        this.buttonContainer.classList.toggle("hidden");
      }
    });
  }
  checkTruncation(element) {
    return element.scrollHeight - element.clientHeight > 1;
  }
  toggleTruncation() {
    this.description.classList.toggle("line-clamp-2");
    this.openButtons.forEach((button) => button.classList.toggle("hidden"));
  }
};
__decorateClass([
  query("[data-collection-description]")
], CommonCollectionGrid.prototype, "description", 2);
__decorateClass([
  query("[data-description-button-container]")
], CommonCollectionGrid.prototype, "buttonContainer", 2);
__decorateClass([
  queryAll("[data-open-description-button]")
], CommonCollectionGrid.prototype, "openButtons", 2);
__decorateClass([
  onClick("[data-open-description-button]")
], CommonCollectionGrid.prototype, "toggleTruncation", 1);
CommonCollectionGrid = __decorateClass([
  defineElement("common-collection-grid")
], CommonCollectionGrid);
export {
  CommonCollectionGrid
};
